import { Rocket } from "lucide-react";

const SDEHero = ({ details }) => {
  return (
    <section className="relative w-full flex items-center justify-center bg-black overflow-hidden py-10 mt-6">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/10 via-black to-black opacity-90" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(128,128,128,0.1),transparent_50%)]" />

      {/* Content Container */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 py-16 lg:py-8">
        <div className="flex flex-col items-center text-center space-y-6 lg:space-y-8">
          {/* Promo Tag */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 backdrop-blur-sm">
            <div className="relative">
              <div className="absolute -inset-0.5 bg-blue-500 rounded-full animate-ping opacity-40" />
              <Rocket className="w-4 h-4 text-blue-400 relative" />
            </div>
            <span className="text-sm font-semibold text-blue-400 tracking-wide uppercase">
              Off-Campus presents
            </span>
          </div>

          {/* Main Headline */}
          <div className="w-full max-w-8xl px-4 sm:px-6">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-white to-gray-500 bg-clip-text text-transparent">
              SDE Intern Fellowship
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-6 max-w-4xl mx-auto">
              Learn how to crack your dream tech internship <br />
              <span className="text-blue-400 italic">
                (without crying over LeetCode at 3 AM)
              </span>
            </p>
          </div>

          {/* Divider */}
          <div className="w-24 h-1 bg-gradient-to-r from-gray-600 to-gray-400 rounded-full" />

          {/* Target Audience */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 to-blue-950 border border-blue-500/20 p-6 md:p-8 mt-8 max-w-3xl">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -mr-32 -mt-32" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl -ml-32 -mb-32" />

            {/* Code pattern background */}
            <div className="absolute inset-0 opacity-5">
              <div className="text-blue-400/20 font-mono text-xs leading-relaxed p-4">
                {`function crackInterview() {
  const skills = ['DSA', 'System Design', 'Projects'];
  const strategy = 'smart preparation';
  return success;
}`}
              </div>
            </div>

            <div className="relative z-10">
              <div className="flex flex-col items-center text-center gap-4">
                {/* Code brackets with animation */}
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-3 rounded-lg bg-blue-500/10 border border-blue-500/20 font-mono text-xl text-blue-400 animate-pulse">
                    {"</>"}
                  </div>
                  <div className="hidden sm:block w-12 h-0.5 bg-gradient-to-r from-blue-400 to-transparent"></div>
                </div>

                <h2 className="text-lg md:text-xl text-center max-w-3xl md:whitespace-nowrap ">
                  <span className="text-amber-400 font-mono">👨‍💻</span>{" "}
                  <span className="text-blue-400">
                    For students who don't just want to
                  </span>{" "}
                  <span className="text-white font-bold">"do DSA"</span>{" "}
                  <span className="text-blue-400">but actually want</span>{" "}
                  <span className="text-green-400 font-bold text-xl">
                    results
                  </span>
                  <span className="text-blue-400 font-mono">.</span>
                </h2>
              </div>
            </div>
          </div>

          {/* Pricing Section - SDE Inspired */}
          <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border border-green-500/30 p-6 max-w-md mx-auto mt-8">
            {/* Terminal-like header */}
            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-700">
              <div className="flex gap-1">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
              </div>
              <span className="text-gray-400 font-mono text-sm ml-2">
                pricing.js
              </span>
            </div>

            {/* Code-style pricing */}
            <div className="font-mono text-sm space-y-2">
              <div className="text-gray-500">
                {"// Investment for your future"}
              </div>
              <div className="flex items-center gap-2">
                <span className="text-blue-400">const</span>
                <span className="text-white">fellowshipPrice</span>
                <span className="text-gray-400">=</span>
                <span className="text-green-400 font-bold text-2xl">
                  ₹{details?.price}
                </span>
                <span className="text-gray-400">;</span>
              </div>
              {/* <div className="text-gray-500 text-xs mt-3">
                {"// ROI: Infinite (when you land that dream internship 🚀)"}
              </div> */}
            </div>

            {/* Subtle glow effect */}
            <div className="absolute inset-0 bg-green-500/5 rounded-xl"></div>
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-transparent via-green-400 to-transparent opacity-50"></div>
          </div>

          {/* CTA */}
          <div className="mt-8">
            <button
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-bold rounded-lg shadow-lg hover:shadow-blue-600/20 transition-all duration-300 hover:scale-105"
              onClick={() => window.open("https://forms.gle/uMpHr5rjz5evyT5K7")}
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent" />
    </section>
  );
};

export default SDEHero;
